// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7557":"af56ba93","7595":"af56ba93"}[chunkId] + ".chunk.css";
};